<script lang="ts">
    export let value: string = '';
    export let disabled: boolean = false;
    export let style: string = '';
    export let className: string = '';
    export let autofocus: boolean = false;
    export let valid: boolean = true;
    export let placeholder: string = '';
</script>

<input class="input-small {className}" type="text" class:invalid-input={!valid}
    bind:value={value}
    disabled={disabled}
    style={style}
    placeholder={placeholder}
    on:keydown
    on:keyup
    on:keypress
    on:change
    on:input
    {autofocus}
/>

<style>
    .input-small {
        /*border: 1px solid #ccc;*/
        /*border-radius: 5px;*/
        /*min-width: 188px;*/
        outline: 0;
        font-weight: 500;
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        color: var(--input-small-color);
        border-radius: var(--input-small-border-radius);
    }
    .input-error {
        border-color: var(--automapa-red);
    }
</style>
